/* unplugin-vue-components disabled */import script from "./Permission.vue?vue&type=script&setup=true&lang=js"
export * from "./Permission.vue?vue&type=script&setup=true&lang=js"

import "./Permission.vue?vue&type=style&index=0&id=e32a0b1e&lang=css"

const __exports__ = script;

export default __exports__